// Hook odpowiedzialny za pobranie statusów zwrotów i reklamacji

import { axios } from 'api';
import { useQuery, UseQueryOptions } from 'react-query';
import {
  ICommandResponseError as IError,
  IPaginationRequest,
  IPaginationResponse,
  ISearchRequest
} from 'api/types';

export interface IReturnsComplaintStatuses {
  status_number: number,
  status: string,
  status_name: string
}

// parametry requestu do api
export type IRequest = IPaginationRequest & ISearchRequest;

// typ zwracanych danych
type IResponse = IPaginationResponse<IReturnsComplaintStatuses>;

const getReturnsComplaintStatuses = (params?: IRequest): Promise<IResponse> => axios.get('/return-complain/statuses', { params });

export const useGetReturnsComplaintStatuses = (params?: IRequest, options?: UseQueryOptions<IResponse, IError>) =>
  useQuery<IResponse, IError>(['statuses', params], () => getReturnsComplaintStatuses(params), options)
